import { gql, useMutation } from "@apollo/client";

import {
  AddDevicesTemplateInput,
  AddDevicesTemplateMutation,
  AddDevicesTemplateMutationVariables,
} from "../../../../../API";
import { ADD_DEVICES_TEMPLATE } from "../../../../../common/operations/mutations";
import { successNotification } from "../../../../../common/variables/notification";
import { handleApolloError } from "../../../../../common/utils/handleApolloError";

export const useCreateDevicesTemplate = () => {
  const [saveDevicesTemplate, { data, loading }] = useMutation<
    AddDevicesTemplateMutation,
    AddDevicesTemplateMutationVariables
  >(ADD_DEVICES_TEMPLATE);

  const createDevicesTemplate = (input: AddDevicesTemplateInput) => {
    return saveDevicesTemplate({
      variables: {
        input,
      },
      onCompleted: response => {
        if (response.addDevicesTemplate) {
          successNotification();
        }
      },
      onError: handleApolloError,
      update: (cache, response): void => {
        cache.modify({
          fields: {
            getDeviceTemplates(existing) {
              const newDeviceTemplateRef = cache.writeFragment({
                data: response.data?.addDevicesTemplate,
                fragment: gql`
                  fragment NewDeviceTemplate on DeviceTemplate {
                    id
                    name
                    numberOfNodes
                    templateData
                  }
                `,
              });

              if (!existing) {
                return response?.data;
              }

              return {
                ...existing,
                items: [...existing.items, newDeviceTemplateRef],
              };
            },
          },
        });
      },
    });
  };

  return { createDevicesTemplate, data, loading };
};
